import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "legal-notice mx-auto readContainer" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-md-6 col-sm-12 mt-4 mb-2" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-dot" }, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-dot" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = ["href"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-telephone" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = ["href"]
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-envelope" }, null, -1)
const _hoisted_18 = { class: "col-md-6 col-sm-12 mt-4 mb-2" }
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = { class: "row mt-4" }
const _hoisted_21 = ["innerHTML"]
const _hoisted_22 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h3", null, _toDisplayString(_ctx.$t( 'legal.contentTitle', { test : 'Hello world' } )), 1),
        _createTextVNode(" " + _toDisplayString(_ctx.legal.nameOfClub) + " ", 1),
        _hoisted_4,
        _hoisted_5,
        _createTextVNode(" " + _toDisplayString(_ctx.legal.responsible) + " ", 1),
        _hoisted_6,
        _createTextVNode(" " + _toDisplayString(_ctx.legal.street) + " ", 1),
        _hoisted_7,
        _createTextVNode(" " + _toDisplayString(_ctx.legal.city) + " ", 1),
        _hoisted_8,
        _createTextVNode(" " + _toDisplayString(_ctx.legal.state) + " ", 1),
        _hoisted_9,
        _createTextVNode(_toDisplayString(_ctx.legal.city), 1),
        _hoisted_10,
        _createTextVNode(" " + _toDisplayString(_ctx.$t( 'legal.carNumber' ) + ': ' + _ctx.legal.carNumber), 1),
        _hoisted_11,
        _hoisted_12,
        _createElementVNode("a", {
          href: 'tel:' + _ctx.legal.phone
        }, [
          _hoisted_14,
          _createTextVNode(" " + _toDisplayString(_ctx.legal.phone), 1)
        ], 8, _hoisted_13),
        _createTextVNode(),
        _hoisted_15,
        _createElementVNode("a", {
          href: 'mailto:' + _ctx.legal.email
        }, [
          _hoisted_17,
          _createTextVNode(" " + _toDisplayString(_ctx.legal.email), 1)
        ], 8, _hoisted_16)
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("h3", null, _toDisplayString(_ctx.$t( 'legal.hostingTitle' )), 1),
        _createElementVNode("div", {
          innerHTML: _ctx.$t('legal.hostingContentHTML')
        }, null, 8, _hoisted_19)
      ])
    ]),
    _createElementVNode("div", _hoisted_20, [
      _createElementVNode("h3", null, _toDisplayString(_ctx.$t( 'legal.rightOfUseTitle' )), 1),
      _createElementVNode("div", {
        innerHTML: _ctx.$t('legal.rightOfUseContent', { club : _ctx.legal.nameOfClub } )
      }, null, 8, _hoisted_21),
      _createElementVNode("h3", null, _toDisplayString(_ctx.$t( 'legal.privacyStatementTitle')), 1),
      _createElementVNode("div", {
        innerHTML: _ctx.$t('legal.privacyStatementContent', {link: _ctx.$t('sitemap.privacyStatement')})
      }, null, 8, _hoisted_22)
    ])
  ]))
}